import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const getProductsCategories = createAsyncThunk<any, any>(
  'products/getProductsCategories',
  async ({vendor_id}, thunkApi) => {
    try {
      const response = await api.get(`/dasht/products/categories`, {
        params: {
          vendor_id
        },
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getProductsSubCategories = createAsyncThunk<any, any>(
  'products/getProductsSubCategories',
  async ({vendor_id, parent_id}, thunkApi) => {
    try {
      const response = await api.get(`/dasht/products/categories/${parent_id}/children`, {
        params: {
          vendor_id
        },
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getProducts = createAsyncThunk<any, any>(
  'products/getProducts',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`/dasht/products`, {
        params: {
          vendor_id: params.vendor_id,
          search: params.search,
          stock_status: params.stock_status,
          badge: params.badge,
          ptk: params.ptk,
          page_size: params.page_size,
          page: params.page,
          sort: params.sort,
          category_id: params.category_id
        },
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);
